import { motion } from "framer-motion";
import { Mail, Sparkles, ArrowRight } from "lucide-react";

export default function Newsletter() {
  return (
    <section
      id="newsletter"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-cream"
      data-testid="newsletter-section"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-[1100px] mx-auto"
      >
        <div className="relative rounded-[32px] bg-gradient-to-br from-terracotta via-[#B85F44] to-[#A8543F] text-cream p-10 md:p-16 lg:p-20 overflow-hidden">
          {/* Animated shimmer */}
          <motion.div
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "linear-gradient(110deg, transparent 40%, rgba(255,235,180,0.18) 50%, transparent 60%)",
              backgroundSize: "200% 100%",
            }}
            animate={{ backgroundPositionX: ["200%", "-100%"] }}
            transition={{ duration: 6, repeat: Infinity, ease: "linear" }}
          />
          {/* Ambient blob */}
          <div className="absolute -top-20 -right-20 w-[400px] h-[400px] rounded-full bg-cream/10 blur-[80px] pointer-events-none" />

          <div className="relative grid md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-7">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-cream/15 backdrop-blur-sm mb-6">
                <Sparkles size={12} className="text-cream" />
                <span className="text-[10px] uppercase tracking-[0.25em] text-cream font-medium">
                  Newsletter Yogi Market
                </span>
              </div>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[0.95]">
                Restez à <span className="italic-serif">l'écoute</span>.
              </h2>
              <p className="mt-6 text-base md:text-lg text-cream/85 font-light leading-relaxed max-w-xl">
                Nouveautés, instruments rares, ventes privées et invitations
                aux bains sonores — directement dans votre boîte mail.
                Une fois par mois, jamais plus.
              </p>
            </div>

            <div className="md:col-span-5">
              <a
                href="https://compiegne.resa.soundyoga.fr/newsletter"
                target="_blank"
                rel="noreferrer"
                className="group flex items-center gap-4 p-5 md:p-6 rounded-2xl bg-cream text-ink hover:bg-walnut hover:text-cream transition-all duration-500 hover:scale-[1.02]"
                data-testid="newsletter-cta"
              >
                <div className="w-12 h-12 rounded-full bg-terracotta flex items-center justify-center shrink-0 group-hover:bg-cream group-hover:text-terracotta transition-colors">
                  <Mail size={18} className="text-cream group-hover:text-terracotta" />
                </div>
                <div className="flex-1">
                  <div className="text-[10px] uppercase tracking-[0.2em] text-ink/55 group-hover:text-cream/70 mb-1">
                    Je m'inscris en 30 secondes
                  </div>
                  <div className="font-serif text-base md:text-lg">
                    S'abonner à la newsletter
                  </div>
                </div>
                <ArrowRight
                  size={18}
                  className="text-ink/40 group-hover:text-cream group-hover:translate-x-1 transition-all"
                />
              </a>
              <p className="text-[10px] text-cream/60 text-center mt-4 uppercase tracking-[0.18em]">
                Désinscription en 1 clic · Pas de spam
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
